import { CalendarOutlined, ClockCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { displayNumbers } from "../../../variables/numbersFunctions";
import dayjs from "dayjs";
import { Popover, Tag, Tooltip } from "antd";

export const cessionParCompagnieColumns = (dateLimiteCession) => {
    return [{
        title: 'Compagnie',
        dataIndex: 'compagnie',
        key: 'compagnie',
        render: (compagnie) => (
            <div>
                <div style={{ fontWeight: 600 }}>{compagnie.raisonSociale}</div>
                <div style={{ fontSize: 12, color: 'var(--retro-text-muted)' }}>{compagnie.code}</div>
            </div>
        )
    },
    {
        title: 'Date cession',
        dataIndex: 'dateCession',
        key: 'dateCession',
        render: (date) => dayjs(date).format('DD/MM/YYYY HH:mm')
    },
    {
        title: 'Retard',
        dataIndex: 'joursRetard',
        key: 'joursRetard',
        render: (jours) => jours > 0 ? (
            <Tag color="error" icon={<ClockCircleOutlined />}>
                {jours} jour(s)
            </Tag>
        ) : (
            <Tag color="success">À temps</Tag>
        )
    },
    {
        title: 'Pénalité',
        dataIndex: 'penalite',
        key: 'penalite',
        render: (penalite, record) => {
            if (!record.detailsPenalite || record.detailsPenalite.total <= 0) {
                return <span style={{ color: '#52c41a' }}>-</span>;
            }

            const details = record.detailsPenalite;

            const popoverContent = (
                <div style={{ width: '350px' }}>
                    {/* En-tête */}
                    <div style={{
                        marginBottom: 16,
                        paddingBottom: 12,
                        borderBottom: '2px solid #ff4d4f'
                    }}>
                        <h4 style={{ margin: 0, color: '#ff4d4f', display: 'flex', alignItems: 'center', gap: 8 }}>
                            <WarningOutlined /> Calcul de la pénalité
                        </h4>
                    </div>

                    {/* Informations de date */}
                    {dateLimiteCession && record.dateCession && (
                        <div style={{
                            marginBottom: 16,
                            padding: '12px',
                            background: '#f5f5f5',
                            borderRadius: '6px'
                        }}>
                            <div style={{ marginBottom: 6, fontSize: '12px' }}>
                                <ClockCircleOutlined style={{ marginRight: 6, color: '#1890ff' }} />
                                <span style={{ color: '#666' }}>Date limite: </span>
                                <strong>{dayjs(dateLimiteCession).format('DD/MM/YYYY')}</strong>
                            </div>
                            <div style={{ marginBottom: 6, fontSize: '12px' }}>
                                <CalendarOutlined style={{ marginRight: 6, color: '#52c41a' }} />
                                <span style={{ color: '#666' }}>Date de cession: </span>
                                <strong>{dayjs(record.dateCession).format('DD/MM/YYYY HH:mm')}</strong>
                            </div>
                            {/* Nombre de jours de retard */}
                            <div style={{ fontSize: '12px' }}>
                                <ClockCircleOutlined style={{ marginRight: 6, color: '#ff4d4f' }} />
                                <span style={{ color: '#666' }}>Nombre de jours de retard: </span>
                                <strong>{record.joursRetard} jour(s)</strong>
                            </div>
                        </div>
                    )}

                    {/* Détails par tranche */}
                    <div style={{ marginBottom: 16 }}>
                        <div style={{
                            fontSize: '13px',
                            fontWeight: 600,
                            marginBottom: 12,
                            color: '#666'
                        }}>
                            📊 Détails du calcul :
                        </div>

                        {details.details && details.details.map((tranche, index) => (
                            <div
                                key={index}
                                style={{
                                    background: '#fff7e6',
                                    border: '1px solid #ffd666',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    marginBottom: index < details.details.length - 1 ? '8px' : '0'
                                }}
                            >
                                {/* Tranche */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: 8
                                }}>
                                    <Tag color="orange" style={{ margin: 0 }}>
                                        {tranche.tranche}
                                    </Tag>
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#666',
                                        fontWeight: 500
                                    }}>
                                        {tranche.joursApplicables} jour(s)
                                    </span>
                                </div>

                                {/* Calcul */}
                                <div style={{ fontSize: '12px', color: '#666', marginBottom: 4 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                                        <span>Pénalité par jour:</span>
                                        <span style={{ fontWeight: 600 }}>
                                            {displayNumbers(tranche.tarifParJour)} F CFA
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>× {tranche.joursApplicables} jour(s) =</span>
                                        <span style={{ fontWeight: 700, color: '#fa8c16', fontSize: '13px' }}>
                                            {displayNumbers(tranche.montantTranche)} F CFA
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Total */}
                    <div style={{
                        marginTop: 16,
                        paddingTop: 16,
                        borderTop: '2px solid #ff4d4f',
                        background: 'linear-gradient(135deg, #fff1f0 0%, #ffccc7 100%)',
                        padding: '16px',
                        borderRadius: '8px'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <span style={{
                                fontSize: '14px',
                                fontWeight: 600,
                                color: '#666'
                            }}>
                                Total pénalité :
                            </span>
                            <span style={{
                                fontSize: '20px',
                                fontWeight: 700,
                                color: '#ff4d4f'
                            }}>
                                {displayNumbers(details.total)} F CFA
                            </span>
                        </div>
                    </div>

                    {/* Note */}
                    <div style={{
                        marginTop: 12,
                        fontSize: '11px',
                        color: '#999',
                        fontStyle: 'italic',
                        textAlign: 'center'
                    }}>
                        Selon les paramètres de pénalités configurés
                    </div>
                </div>
            );

            return (
                <Popover
                    content={popoverContent}
                    title={null}
                    trigger="hover"
                    placement="left"
                    overlayStyle={{ maxWidth: '400px' }}
                >
                    <div style={{
                        cursor: 'help',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '4px 12px',
                        background: '#fff1f0',
                        borderRadius: '6px',
                        border: '1px solid #ffa39e'
                    }}>
                        <WarningOutlined style={{
                            fontSize: '16px',
                            color: '#ff4d4f'
                        }} />
                        <span style={{
                            color: '#ff4d4f',
                            fontWeight: 600,
                            fontSize: '15px'
                        }}>
                            {displayNumbers(details.total)} F CFA
                        </span>
                    </div>
                </Popover>
            );
        },
        align: 'right',
        sorter: (a, b) => (a.detailsPenalite?.total || 0) - (b.detailsPenalite?.total || 0),
    },
    {
        title: 'Émissions',
        dataIndex: 'totalEmissionsRetrocedees',
        key: 'emissions',
        render: (total) => (
            <span style={{ color: 'var(--retro-success)', fontWeight: 500 }}>
                {displayNumbers(total)} F
            </span>
        ),
        align: 'right'
    },
    {
        title: 'Sinistres',
        key: 'sinistres',
        render: (_, record) => (
            <span style={{ color: 'var(--retro-danger)', fontWeight: 500 }}>
                {displayNumbers(record.totalSinistres)} F
            </span>
        ),
        align: 'right'
    }]
}

const compagnieFromNumeroPolice = (numeroPolice) => {
    if (!numeroPolice || numeroPolice.length < 2) return null;

    const prefix = numeroPolice.substring(0, 2);

    const mapping = {
        "01": "FIDELIA ASSURANCES",
        "02": "NSIA ASSURANCES",
        "03": "SANLAM ALLIANZ TOGO",
        "04": "GTA ASSURANCES SA",
        "05": "SUNU IARD",
    };

    return mapping[prefix] || null;
};

// Fonction pour générer les colonnes dynamiques basées sur les compagnies
export const emissionsColumns = (compagnies = [], isGlobalView = false) => {
    const baseColumns = [
        {
            title: 'N° Police',
            dataIndex: 'numeroPolice',
            key: 'numeroPolice',
            width: 90,
            fixed: 'left',
            render: (value, record) => {
                const compagnieLabel =
                    record?.compagnie?.raisonSociale ||
                    compagnieFromNumeroPolice(value);

                return (
                    <div>
                        <div style={{ fontWeight: 500 }}>{value || 'N/A'}</div>
                        {isGlobalView && compagnieLabel && (
                            <Tag
                                color="blue"
                                style={{
                                    marginTop: 4,
                                    fontSize: 10,
                                    padding: '0 4px',
                                    lineHeight: '16px'
                                }}
                            >
                                {compagnieLabel}
                            </Tag>
                        )}
                    </div>
                )
            },
        },
        // {
        //     title: 'Assuré',
        //     dataIndex: 'assure',
        //     key: 'assure',
        //     width: 150,
        //     ellipsis: true,
        // },
        {
            title: 'Effet',
            dataIndex: 'effet',
            key: 'effet',
            width: 60,
            render: (date) => date && date !== 'N/A' ? dayjs(date).format('DD/MM/YYYY') : 'N/A',
        },
        {
            title: 'Échéance',
            dataIndex: 'echeance',
            key: 'echeance',
            width: 60,
            render: (date) => date && date !== 'N/A' ? dayjs(date).format('DD/MM/YYYY') : 'N/A',
        },
        {
            title: 'Prime cédée',
            dataIndex: 'primeACeder',
            key: 'primeACeder',
            width: 70,
            align: 'right',
            render: (value) => <strong>{displayNumbers(value || 0)} F</strong>,
        },
    ];

    // Colonnes dynamiques pour chaque compagnie
    const compagnieColumns = compagnies.map((compagnie) => ({
        title: (
            <Tooltip title={compagnie.raisonSociale || compagnie.compagnieNom}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 600, fontSize: 12 }}>{compagnie.raisonSociale || compagnie.compagnieNom}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>Taux / Montant</div>
                </div>
            </Tooltip>
        ),
        key: `compagnie_${compagnie.code || compagnie.compagnieCode}`,
        width: 100,
        align: 'center',
        children: [
            {
                title: 'Taux',
                dataIndex: ['repartition'],
                key: `taux_${compagnie.code || compagnie.compagnieCode}`,
                width: 50,
                align: 'right',
                render: (repartition) => {
                    const rep = repartition?.find(r => r.compagnieCode === (compagnie.code || compagnie.compagnieCode));
                    const taux = rep ? rep.taux : 0;
                    return <span style={{ color: '#1890ff' }}>{(taux).toFixed(2)}%</span>;
                },
            },
            {
                title: 'Montant',
                dataIndex: ['repartition'],
                key: `montant_${compagnie.code || compagnie.compagnieCode}`,
                width: 70,
                align: 'right',
                render: (repartition) => {
                    const rep = repartition?.find(r => r.compagnieCode === (compagnie.code || compagnie.compagnieCode));
                    const montant = rep ? rep.montant : 0;
                    return <span style={{ color: '#52c41a', fontWeight: 500 }}>{displayNumbers(montant)} F</span>;
                },
            },
        ],
    }));

    // Colonne total rétrocédé
    const totalColumn = {
        title: 'Total Rétrocédé',
        dataIndex: 'totalRetrocede',
        key: 'totalRetrocede',
        width: 140,
        align: 'right',
        fixed: 'right',
        render: (value) => (
            <strong style={{ color: '#722ed1', fontSize: 14 }}>
                {displayNumbers(value || 0)} F
            </strong>
        ),
    };

    return [...baseColumns, ...compagnieColumns, totalColumn];
};

export const annulationsColumns = (compagnies = [], isGlobalView = false) => {
    const baseColumns = [
        {
            title: 'N° Police',
            dataIndex: 'numeroPolice',
            key: 'numeroPolice',
            width: 90,
            fixed: 'left',
            render: (value, record) => {
                const compagnieLabel =
                    record?.compagnie?.raisonSociale ||
                    compagnieFromNumeroPolice(value);

                return (
                    <div>
                        <div style={{ fontWeight: 500 }}>{value || 'N/A'}</div>
                        {isGlobalView && compagnieLabel && (
                            <Tag
                                color="blue"
                                style={{
                                    marginTop: 4,
                                    fontSize: 10,
                                    padding: '0 4px',
                                    lineHeight: '16px'
                                }}
                            >
                                {compagnieLabel}
                            </Tag>
                        )}
                    </div>
                )
            },
        },
        // {
        //     title: 'Assuré',
        //     dataIndex: 'assure',
        //     key: 'assure',
        //     width: 150,
        //     ellipsis: true,
        // },
        {
            title: 'Compagnie cédante',
            dataIndex: 'compagnieCedante',
            key: 'compagnieCedante',
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{record.compagnie?.raisonSociale}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>{record.compagnie?.code}</div>
                </div>
            ),
            width: 150,
            ellipsis: true,
        },
        {
            title: 'Avenant',
            dataIndex: 'avenant',
            key: 'avenant',
            width: 100,
        },
        {
            title: 'Prime cédée',
            dataIndex: 'primeACeder',
            key: 'primeACeder',
            width: 130,
            align: 'right',
            render: (value) => <strong style={{ color: '#faad14' }}>{displayNumbers(Math.abs(value) || 0)} F</strong>,
        },
    ];

    const compagnieColumns = compagnies.map((compagnie) => ({
        title: (
            <Tooltip title={compagnie.raisonSociale || compagnie.compagnieNom}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 600, fontSize: 12 }}>{compagnie.raisonSociale || compagnie.compagnieNom}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>Taux / Montant</div>
                </div>
            </Tooltip>
        ),
        key: `compagnie_${compagnie.compagnieNom || compagnie.compagnieCode}`,
        width: 140,
        align: 'center',
        children: [
            {
                title: 'Taux',
                dataIndex: ['repartition'],
                key: `taux_${compagnie.code || compagnie.compagnieCode}`,
                width: 70,
                align: 'right',
                render: (repartition) => {
                    const rep = repartition?.find(r => r.compagnieCode === (compagnie.code || compagnie.compagnieCode));
                    const taux = rep ? rep.taux : 0;
                    return <span style={{ color: '#1890ff' }}>{(taux).toFixed(2)}%</span>;
                },
            },
            {
                title: 'Montant',
                dataIndex: ['repartition'],
                key: `montant_${compagnie.code || compagnie.compagnieCode}`,
                width: 100,
                align: 'right',
                render: (repartition) => {
                    const rep = repartition?.find(r => r.compagnieCode === (compagnie.code || compagnie.compagnieCode));
                    const montant = rep ? rep.montant : 0;
                    return <span style={{ color: '#faad14', fontWeight: 500 }}>{displayNumbers(Math.abs(montant))} F</span>;
                },
            },
        ],
    }));

    const totalColumn = {
        title: 'Total Rétrocédé',
        dataIndex: 'totalRetrocede',
        key: 'totalRetrocede',
        width: 140,
        align: 'right',
        fixed: 'right',
        render: (value) => (
            <strong style={{ color: '#722ed1', fontSize: 14 }}>
                {displayNumbers(Math.abs(value) || 0)} F
            </strong>
        ),
    };

    return [...baseColumns, ...compagnieColumns, totalColumn];
};

export const sinistresColumns = (compagnies = []) => {
    const baseColumns = [
        {
            title: 'N° Sinistre',
            dataIndex: 'sinistreNumSinistre',
            key: 'sinistreNumSinistre',
            width: 120,
            fixed: 'left',
        },
        {
            title: 'N° Police',
            dataIndex: 'sinistreNumPolice',
            key: 'sinistreNumPolice',
            width: 120,
        },
        {
            title: 'Souscripteur',
            dataIndex: 'sinistreSouscripteur',
            key: 'sinistreSouscripteur',
            width: 150,
            ellipsis: true,
        },
        {
            title: 'Date de survenance',
            dataIndex: 'dateSinistre',
            key: 'dateSinistre',
            width: 100,
            render: (date) => date && date !== 'N/A' ? dayjs(date).format('DD/MM/YYYY') : 'N/A',
        },
        {
            title: 'Bénéficiaire',
            dataIndex: 'beneficiaire',
            key: 'beneficiaire',
            width: 150,
            ellipsis: true,
        },
        {
            title: 'Montant',
            dataIndex: 'montant',
            key: 'montant',
            width: 130,
            align: 'right',
            render: (value) => <strong style={{ color: '#ff4d4f' }}>{displayNumbers(value || 0)} F</strong>,
        },
    ];

    const compagnieColumns = compagnies.map((compagnie) => ({
        title: (
            <Tooltip title={compagnie.raisonSociale || compagnie.compagnieNom}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 600, fontSize: 12 }}>{compagnie.raisonSociale || compagnie.compagnieNom}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>Taux / Montant</div>
                </div>
            </Tooltip>
        ),
        key: `compagnie_${compagnie.code || compagnie.compagnieCode}`,
        width: 140,
        align: 'center',
        children: [
            {
                title: 'Taux',
                dataIndex: ['repartition'],
                key: `taux_${compagnie.code || compagnie.compagnieCode}`,
                width: 70,
                align: 'right',
                render: (repartition) => {
                    const rep = repartition?.find(r => r.compagnieCode === (compagnie.code || compagnie.compagnieCode));
                    const taux = rep ? rep.taux : 0;
                    return <span style={{ color: '#1890ff' }}>{(taux).toFixed(2)}%</span>;
                },
            },
            {
                title: 'Montant',
                dataIndex: ['repartition'],
                key: `montant_${compagnie.code || compagnie.compagnieCode}`,
                width: 100,
                align: 'right',
                render: (repartition) => {
                    const rep = repartition?.find(r => r.compagnieCode === (compagnie.code || compagnie.compagnieCode));
                    const montant = rep ? rep.montant : 0;
                    return <span style={{ color: '#ff4d4f', fontWeight: 500 }}>{displayNumbers(montant)} F</span>;
                },
            },
        ],
    }));

    const totalColumn = {
        title: 'Total Rétrocédé',
        dataIndex: 'totalRetrocede',
        key: 'totalRetrocede',
        width: 140,
        align: 'right',
        fixed: 'right',
        render: (value) => (
            <strong style={{ color: '#722ed1', fontSize: 14 }}>
                {displayNumbers(value || 0)} F
            </strong>
        ),
    };

    return [...baseColumns, ...compagnieColumns, totalColumn];
};

export const recoursColumns = (compagnies = []) => {
    const baseColumns = [
        {
            title: 'N° Sinistre',
            dataIndex: 'sinistreNumSinistre',
            key: 'sinistreNumSinistre',
            width: 120,
            fixed: 'left',
        },
        {
            title: 'N° Police',
            dataIndex: 'sinistreNumPolice',
            key: 'sinistreNumPolice',
            width: 120,
        },
        {
            title: 'Souscripteur',
            dataIndex: 'sinistreSouscripteur',
            key: 'sinistreSouscripteur',
            width: 150,
            ellipsis: true,
        },
        {
            title: 'Date de surenance',
            dataIndex: 'dateSinistre',
            key: 'dateSinistre',
            width: 100,
            render: (date) => date && date !== 'N/A' ? dayjs(date).format('DD/MM/YYYY') : 'N/A',
        },
        {
            title: 'Montant',
            dataIndex: 'montant',
            key: 'montant',
            width: 130,
            align: 'right',
            render: (value) => <strong style={{ color: '#13c2c2' }}>{displayNumbers(value || 0)} F</strong>,
        },
    ];

    const compagnieColumns = compagnies.map((compagnie) => ({
        title: (
            <Tooltip title={compagnie.raisonSociale || compagnie.compagnieNom}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 600, fontSize: 12 }}>{compagnie.raisonSociale || compagnie.compagnieNom}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>Taux / Montant</div>
                </div>
            </Tooltip>
        ),
        key: `compagnie_${compagnie.code || compagnie.compagnieCode}`,
        width: 140,
        align: 'center',
        children: [
            {
                title: 'Taux',
                dataIndex: ['repartition'],
                key: `taux_${compagnie.code || compagnie.compagnieCode}`,
                width: 70,
                align: 'right',
                render: (repartition) => {
                    const rep = repartition?.find(r => r.compagnieCode === (compagnie.code || compagnie.compagnieCode));
                    const taux = rep ? rep.taux : 0;
                    return <span style={{ color: '#1890ff' }}>{(taux).toFixed(2)}%</span>;
                },
            },
            {
                title: 'Montant',
                dataIndex: ['repartition'],
                key: `montant_${compagnie.code || compagnie.compagnieCode}`,
                width: 100,
                align: 'right',
                render: (repartition) => {
                    const rep = repartition?.find(r => r.compagnieCode === (compagnie.code || compagnie.compagnieCode));
                    const montant = rep ? rep.montant : 0;
                    return <span style={{ color: '#13c2c2', fontWeight: 500 }}>{displayNumbers(montant)} F</span>;
                },
            },
        ],
    }));

    const totalColumn = {
        title: 'Total Rétrocédé',
        dataIndex: 'totalRetrocede',
        key: 'totalRetrocede',
        width: 140,
        align: 'right',
        fixed: 'right',
        render: (value) => (
            <strong style={{ color: '#722ed1', fontSize: 14 }}>
                {displayNumbers(value || 0)} F
            </strong>
        ),
    };

    return [...baseColumns, ...compagnieColumns, totalColumn];
};